import { FC, useEffect } from "react";
import { CompanyNameChangeForm } from "./companyNameChangeDomain";
import { observer } from "mobx-react";
import { ArticleSelectorQuestion } from "../common/commonComponents";
import { VBox } from "../../components-v2/Box";
import { MTextInput } from "../../components-v2/TextInput";

import { useTranslation } from "../../stores/RootStoreContext";

export const CompanyNameView: FC<{ form: CompanyNameChangeForm }> = observer(({ form }) => {
  const { t } = useTranslation();

  useEffect(() => {
    form.init();
  }, [form]);

  return (
    <VBox gap={"md"}>
      <MTextInput
        label={t("decisions.companyName.newCompanyName-helperText")}
        model={form.newCompanyName}
        disabled={form.isProjectLocked}
      />

      <ArticleSelectorQuestion
        question={t("decisions.companyName.paragraph-helperText")}
        model={form.articleOfAssociationNumber}
        isLocked={form.isProjectLocked}
      />
    </VBox>
  );
});
